/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React from 'react'
import { createGlobalStyle, css, ThemeProvider as StyledComponentsThemeProvider } from 'styled-components'
import colors from './colors'
import { fontSize, fontWeight } from './fonts'

export const MEDIA_WIDTHS = {
  upToExtraSmall: 414,
  upToSmall: 768,
  upToMedium: 960,
  upToLarge: 1280
}

const mediaWidthTemplates = Object.keys(MEDIA_WIDTHS).reduce(
  (accumulator, size) => {
    (accumulator)[size] = (a, b, c) => css`
      @media (max-width: ${(MEDIA_WIDTHS)[size]}px) {
        ${css(a, b, c)}
      }
    `
    return accumulator
  },
  {}
)
const input = {
  input_small: '380px',
  input_medium: '512px',
  input_large: '810px'
}

const theme = () => ({
  ...colors,
  ...fontSize,
  ...fontWeight,
  grids: {
    sx: 8,
    sm: 16,
    md: 24,
    lg: 32
  },
  // font size for text
  size_16: '16px',
  size_17: '17px',
  size_18: '18px',
  size_14: '14px',
  size_13: '13px',
  size_12: '12px',

  ...input,
  // media queries
  mediaWidth: mediaWidthTemplates
})

export default function ThemeProvider({ children }) {
  return <StyledComponentsThemeProvider theme={theme()}>{children}</StyledComponentsThemeProvider>
}

export const ThemedGlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    height: 100%;
  }

  body {
    font-family: Inter, system-ui, -apple-system, sans-serif;
    background-color: ${({ theme }) => theme.bg_primary_light};
    min-height: 100vh;
    height: 100%;
    margin: 0;
    padding: 0;

    #root {
      width: 100%;
      height: 100%;
    }

    // remove unnecessary whitespace in formTimePicker
    .ant-picker-time-panel-column {
      &:after {
        content: none;
      }
    }
  }

  a {
    color: ${({ theme }) => theme.primary};

    &:hover,
    &:active {
      color: #2563EB;
    }
  }

  // antd custom
  .ant-dropdown-menu {
    border-radius: 8px;

    .ant-dropdown-menu-item {
      border-radius: 8px;
      padding: 0.5rem;
      margin: .25rem .5rem;
      color: ${({ theme }) => theme.text_secondary};

      &:not(.ant-dropdown-menu-item-disabled) {
        &:hover {
          background-color: #EFF6FF;
          color: ${({ theme }) => theme.primary};

          .logout-icon {
            fill: ${({ theme }) => theme.primary};
          }
        }
      }

      .ant-dropdown-menu-title-content {
        display: flex;
        align-items: center;
      }
    }

    .ant-dropdown-menu-item-divider {
      width: 90%;
      margin: 0 auto;
    }
  }

  .ant-form-item {
    margin-bottom: 0;

    &.inline-label:first-child {
      margin-bottom: 2px;
    }
  }

  // ANTD Popover
  .ant-popover {
    min-width: 193px;
    padding-top: 3px;

    .ant-popover-arrow {
      display: none;
    }

    .ant-popover-inner-content {
      padding: 0;
    }

    .popover-content {
      p {
        margin: 0;
        border: 1px solid ${({ theme }) => theme.border};

        &:first-of-type {
          border-top: none;
        }
      }

      a {
        display: block;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        padding: 10px 0;

        color: ${({ theme }) => theme.black};
      }
    }
  }

  .ant-btn {
    border-radius: 8px;
    width: 100%;
    height: 31px;
    max-width: 238px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;

    &:not(.ant-btn-primary):not(.ant-btn-secondary):not(.ant-btn-cancel):hover,
    &:not(.ant-btn-primary):not(.ant-btn-secondary):not(.ant-btn-cancel):active,
    &:not(.ant-btn-primary):not(.ant-btn-secondary):not(.ant-btn-cancel):focus,
    &:not(.ant-btn-primary):not(.ant-btn-secondary):not(.ant-btn-cancel):focus-visible {
      outline: none;
      background: none;
      border: none;
    }

    &.ant-btn-primary {
      background-color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.white};

      &[disabled] {
        color: ${({ theme }) => theme.text_secondary};
        background-color: #E5E7EB;
        border-color: #E5E7EB;

        &:hover,
        &:active,
        &:focus {
          color: ${({ theme }) => theme.text_secondary};
        }
      }
    }

    &.ant-btn-secondary {
      background-color: transparent;
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};

      &[disabled] {
        background-color: transparent;
        border-color: #E5E7EB;
        color: ${({ theme }) => theme.text_secondary};

        &:hover,
        &:active,
        &:focus {
          color: ${({ theme }) => theme.text_secondary};
        }
      }
    }

    &.ant-btn-tertiary {
      background-color: transparent;
      border-color: transparent;
      color: ${({ theme }) => theme.primary};

      &[disabled] {
        background-color: transparent;
        border-color: transparent;
        color: ${({ theme }) => theme.text_secondary};

        &:hover,
        &:active,
        &:focus {
          color: ${({ theme }) => theme.text_secondary};
        }
      }
    }

    &.ant-btn-cancel {
      background: ${({ theme }) => theme.text_secondary};
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      color: ${({ theme }) => theme.white};
      border-color: transparent;

      &[disabled] {
        background-color: transparent;
        border-color: transparent;
        color: ${({ theme }) => theme.text_secondary};

        &:hover,
        &:active,
        &:focus {
          color: ${({ theme }) => theme.white};
        }
      }
    }
  }

  .ant-select {
    &:hover {
      border-bottom: none !important;
    }

    &-selection-item {
      color: ${({ theme }) => theme.text_primary};
      font-weight: 600;
    }
  }

  .ant-input,
  .ant-select {
    &,
    &-password,
    &:not(.ant-select-customize-input) &-selector {
      &:not(.payment-input) {
        color: ${({ theme }) => theme.text_primary};
        border-top: none;
        border-left: none;
        border-right: none;
        font-weight: 600;
      }

      &:focus, &:hover {
        background-color: transparent;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 2px solid ${({ theme }) => theme.primary};
        outline: 0;
        box-shadow: none;
      }

      &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;

        color: ${({ theme }) => theme.text_secondary};
      }
    }

    &.payment-input {
      border: 1px solid ${({ theme }) => theme.border};
    }
  }

  .input-number {
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &:focus, &:hover {
      outline: 0;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }

    & .prefix {
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
    }

    & .ant-input-number {

      & .ant-input-number-input {
        color: ${({ theme }) => theme.white};
        font-size: .8rem;
        font-weight: 600;
      }

      & .ant-input-number-handler-wrap {
        background-color: transparent;
      }
    }
  }

  .ant {
    &-row {
      .ant-col {
        &.ant-form-item-label {
          display: block;
          width: 100%;
          text-align: left;

          label {
            margin: 0;
            flex: 1;
            font-weight: 700;
            font-size: 10px;
            line-height: 20px;

            color: ${({ theme }) => theme.black};
          }
        }
      }

      &.inline-label {
        .ant-col {
          &.ant-form-item-label {
            width: auto;
            display: inline-block;
            vertical-align: middle;
          }

          span {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
    }
  }

  .ant-message {
    z-index: 1200;
  }

  .ant-tree {
    border-radius: .75rem;
  }

  .ant-tooltip {
    max-width: unset;

    &-placement-topLeft {
      padding: 0 !important;
    }
  }

  .ant-picker-month-panel {
    .ant-picker-header {
      display: none;
    }
  }

  .tutorial-tooltip {
    border: none;

    .ant-tooltip-arrow {
      .ant-tooltip-arrow-content {
        --antd-arrow-background-color: #EFF6FF;
      }
    }

    .ant-tooltip-inner {
      padding: 20px;
      background: #EFF6FF;
      border: 1px solid ${({ theme }) => theme.border};
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 8px;
    }
  }

  .ant-form-item-explain-error {
    line-break: anywhere;
  }

  .ant-picker {
    width: 100%;
  }
`
